<app-card #card
    [cardTitle]="componentTitleKey | translate"
    [useExternalButtons]="true"    
    [disabled]="!appState.company.value" 
    [showEdit]="false" 
    (editToggle)="onCardEditToggle($event)">

    <div slot="readonly">
        <ng-container *ngIf="list$ | async as list">
            <ng-container>
                <div class="flex-horizontal top-margin-off">
                    <mat-form-field appearance="outline" class="flex-fill">
                        <mat-select [(value)]="reviewPeriod" disableOptionCentering class="drop-fix select-multi-line" [readonly]="true" (selectionChange)="changePeriod($event)">                            
                            <mat-option *ngFor="let rp of list" [value]="rp">
                                {{ getDisplayText(rp) }}
                            </mat-option>                            
                        </mat-select>
                    </mat-form-field>
                    
                    <ng-container *ngIf="configMode">
                        <div *ngxPermissionsOnly="['SuperAdmin', 'Admin']" class="rp-buttons">
                            <button mat-icon-button color="primary" (click)="add()">
                                <mat-icon>add_circle_outline</mat-icon>
                            </button>
                            <button mat-icon-button color="primary" (click)="edit()" [disabled]="!selectedReviewPeriod.value">
                                <mat-icon>edit</mat-icon>
                            </button>
                            <button mat-icon-button color="primary" (click)="delete(selectedReviewPeriod.value)" [disabled]="selectedReviewPeriod.value == null" [title]="'REVIEW_PERIOD.DELETE_EVALUATION' | translate">
                                <mat-icon>delete</mat-icon>
                            </button>
                        </div>
                    </ng-container>
                </div>
                
                <mat-form-field appearance="outline" class="full-width" *ngIf="configMode && reviewPeriod && !isSziluett(reviewPeriod.reviewType)">
                    <mat-label>{{ 'REVIEW_PERIOD.VALIDITY_PERIOD' | translate }}</mat-label>
                    <mat-date-range-input [rangePicker]="picker">
                      <input matStartDate [(ngModel)]="reviewPeriod.startDate" readonly [placeholder]="'REVIEW_PERIOD.START' | translate">
                      <input matEndDate [(ngModel)]="reviewPeriod.endDate" readonly [placeholder]="'REVIEW_PERIOD.END' | translate">
                    </mat-date-range-input>
                </mat-form-field>
        
                <ng-container>
                    <div *ngIf="configMode && selectedReviewPeriod.value && reviewPeriod" class="status">
                        <mat-form-field appearance="outline" class="flex-fill">
                            <mat-label>{{ 'REVIEW_PERIOD.STATUS' | translate }}</mat-label>
                            <mat-select [(value)]="reviewPeriod.status" [disabled]="!allowChangeState()" disableOptionCentering class="drop-fix" (selectionChange)="changeStatus($event)">
                                <mat-option *ngFor="let status of statusList" [value]="status.id">{{ status.translateKey | translate }}</mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                </ng-container>

                <div class="flex-h gap-2 flex-wrap">
                    <ng-container *ngIf="showRpButtonGroup && showStat">
                        <button mat-flat-button color="primary" (click)="downloadExport(selectedReviewPeriod.value.id)" *ngxPermissionsOnly="['SuperAdmin', 'Admin', 'Assistant']">
                            <mat-icon>article_outline</mat-icon> {{ 'REVIEW_PERIOD.STATISTICS' | translate }}
                        </button>
                    </ng-container>

                    <ng-container *ngIf="showRpButtonGroup">
                        <button mat-flat-button color="primary" (click)="showEmailAdmin(selectedReviewPeriod.value.id)" *ngxPermissionsOnly="['SuperAdmin', 'Admin']">
                            <mat-icon>mail</mat-icon> {{ 'REVIEW_PERIOD.EMAIL' | translate }}
                        </button>
                        <ng-container>
                            <button mat-flat-button color="primary" (click)="showUploadDialog(selectedReviewPeriod.value.id)" *ngxPermissionsOnly="['SuperAdmin', 'Admin']">
                                <mat-icon>system_update_alt</mat-icon> {{ 'REVIEW_PERIOD.UPLOAD' | translate }}
                            </button>
                            <ng-container *ngIf="isTestMode">
                                <button mat-flat-button color="primary" (click)="testDatabaseRestore()" *ngxPermissionsOnly="['SuperAdmin', 'Admin']">
                                    <mat-icon>list_alt_add</mat-icon> {{ 'REVIEW_PERIOD.TRANSFER_LIVE_DATA' | translate }}
                                </button>
                            </ng-container>
                        </ng-container>
                    </ng-container>

                    <a mat-flat-button color="primary" [routerLink]="['/position']" *ngxPermissionsOnly="['SuperAdmin', 'Admin', 'Assistant']">
                        <mat-icon>list_alt_add</mat-icon> {{ 'REVIEW_PERIOD.POSITIONS' | translate }}
                    </a>
                    <a mat-flat-button color="primary" [routerLink]="['/reports/position-profile-report']" *ngxPermissionsOnly="['SuperAdmin', 'Admin', 'Assistant']">
                        <mat-icon>list_alt_add</mat-icon> {{ 'REVIEW_PERIOD_COMPONENT.SZILUETT_FIT' | translate }}
                    </a>
                </div>

            </ng-container>
        </ng-container>
    </div>

    <div slot="edit">
        <app-review-period-edit #editComponent [selectedReviewPeriod]="selectedReviewPeriod.value" (closeEdit)="closeEdit()" (saved)="dataSaved($event)"></app-review-period-edit>
    </div>
</app-card>
